import React, { useState } from 'react';
import { useItems } from 'hooks/atoms/items-hook';
import CollectionKeys from 'hooks/molecules/collection-keys';
import AppLoader from 'components/basic/AppLoader';
import ManagersEditCorporate from 'components/business/local-manager/ManagersEditCorporate';
import { Grid, Select, Typography, FormControl,
  MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TablePagination, Paper, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import { roles } from 'cassandra-shared-js/roles';
import usePermissions from 'hooks/permissions-hooks';

const useStyles = makeStyles({
  subtitle: {
    margin: '0px 0px 5px 5px',
    color: 'rgb(100, 141, 174)',
    fontSize: 18,
  },
  button: {
    margin: '0px 0px 0px 5px',
    fontSize: 18,
    borderColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
  selectLocation: {
    fontSize: 18,
    color: 'rgb(100, 141, 174)',
    margin: '0px 0px 20px 5px',
  },
  searchBox: {
    fontSize: 18,
    color: 'rgb(100, 141, 174)',
    margin: '6px 0px 0px 5px',
  },
  tableContainer: {
    margin: 'auto',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  },
  table: {
    minWidth: 650,
  },
  headerCell: {
    backgroundColor: 'rgb(100, 141, 174)',
    color: '#f0f4f8',
    fontWeight: 600,
    fontSize: 16,
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa',
    },
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  infoButton: {
    color: '#ffffff',
    backgroundColor: 'rgb(100, 141, 174)',
    '&:hover': {
      backgroundColor: 'rgb(41, 58, 136)',
    },
  },
  dialogPaperEdit: {
    width: '100%',
    maxWidth: 600,
  },
  dialogContent: {
    backgroundColor: '#f3f3f3',
  },
});

function ManagerCorporationTable({ country, setCountry }) {
  const { userHasRole } = usePermissions();
  const classes = useStyles();
  const [ filterQuery, setFilterQuery ] = useState({});
  const [ openDialogEdit, setOpenDialogEdit ] = useState(false);
  const [ selected, setSelected ] = useState({});
  const [ searchCorporation, setSearchCorporation ] = useState('');
  const [ searchBy, setSearchBy ] = useState('name');
  // get Corporations
  const {
    countFiltered,
    items: allCorporations,
    itemsLoading: allCorporationsLoading,
    itemsFetching: allCorporationsFetching,
    itemsError: allCorporationsError,
    pagination,
    refetch,
  } = useItems(CollectionKeys.BUSINESSES, { filterQuery: {
    _where: [{ country }],
    ...filterQuery,
  },
  queryOptions: { refetchOnWindowFocus: false } });

  const handleSearch = (value) => {
    const newFilter = { brand_name_contains: value };
    const newMotherFilter = { 'mother_business.brand_name_contains': value };
    if (searchBy === 'name') {
      setFilterQuery(newFilter);
    } else {
      setFilterQuery(newMotherFilter);
    }
    refetch();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      setSearchCorporation(e.target.value);
      handleSearch(searchCorporation);
    }
  };

  if (allCorporationsError) {
    return (
      <span>
        Error:
        {allCorporationsError}
      </span>
    );
  }
  return (
    <Grid container spacing={ 2 } alignItems='center' style={ { backgroundColor: '#ffffff' } }>
      <Grid item xs={ 12 }>
        <div className={ classes.subtitle }>
          Entries:
          {' '}
          {countFiltered}
        </div>
      </Grid>
      {userHasRole(roles.ADMINISTRATOR_ROLE)
          && (
            <Grid item xs={ 6 } md={ 2 } display='flex'>
              <FormControl style={ { width: '100%' } } className={ classes.selectLocation }>
                <Typography
                  variant='subtitle'
                  id='location-select-label'
                >
                  Location:
                </Typography>
                <Select
                  variant='outlined'
                  size='small'
                  labelId='country-select-label'
                  id='country-select'
                  value={ country }
                  onChange={ (e) => { setCountry(e.target.value); refetch(); } }
                >
                  <MenuItem value='GR'>Greece</MenuItem>
                  <MenuItem value='AL'>Albania</MenuItem>
                  <MenuItem value='IN'>India</MenuItem>
                  <MenuItem value='IQ'>Iraq</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
      <Grid item xs={ 6 } md={ 2 } display='flex'>
        <FormControl style={ { width: '100%' } } className={ classes.selectLocation }>
          <Typography
            variant='subtitle'
            id='searchBy-select-label'
          >
            Search By:
          </Typography>
          <Select
            variant='outlined'
            size='small'
            labelId='searchBy-select-label'
            id='search-select'
            value={ searchBy }
            onChange={ (e) => { setSearchCorporation(''); setSearchBy(e.target.value); refetch(); } }
          >
            <MenuItem value='name'>Name</MenuItem>
            <MenuItem value='motherName'>Mother Name</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={ 6 } md={ 2 } display='flex'>
        <TextField
          className={ classes.searchBox }
          id='search-bar'
          size='medium'
          value={ searchCorporation }
          onChange={ (e) => { setSearchCorporation(e.target.value); } }
          onKeyPress={ (e) => { handleKeyPress(e); } }
          label='Enter Name'
          variant='outlined'
        />
      </Grid>

      <Grid item xs={ 6 } display='flex'>
        <Button
          className={ classes.button }
          variant='outlined'
          size='large'
          onClick={ () => { handleSearch(searchCorporation); } }
        >
          <SearchIcon />
          SEARCH
        </Button>
        { searchCorporation.length > 0
      && (
        <Button
          className={ classes.button }
          variant='outlined'
          size='large'
          onClick={ () => {
            setSearchCorporation('');
            setFilterQuery({});
          } }
        >
          CLEAR
        </Button>
      )}
      </Grid>
      <Grid item xs={ 12 } md={ 12 }>
        <Paper>
          <TableContainer className={ classes.tableContainer }>
            { (allCorporationsLoading || allCorporationsFetching) ? <AppLoader />
              : (
                <Table className={ classes.table }>
                  <TableHead>
                    <TableRow>
                      <TableCell className={ classes.headerCell }>Name</TableCell>
                      <TableCell className={ classes.headerCell }>Email</TableCell>
                      <TableCell className={ classes.headerCell }>Type</TableCell>
                      <TableCell className={ classes.headerCell }>Mother Corporation</TableCell>
                      <TableCell className={ classes.headerCell }>Edit</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {allCorporations.map((corporation) => {
                      return (
                        <TableRow key={ corporation.id } className={ classes.row }>
                          <TableCell>{corporation?.brand_name}</TableCell>
                          <TableCell>{corporation?.email}</TableCell>
                          <TableCell>{corporation?.type}</TableCell>
                          <TableCell>{corporation?.mother_business?.brand_name || '-'}</TableCell>
                          <TableCell>
                            <Button
                              className={ classes.infoButton }
                              onClick={ () => { setSelected(corporation); setOpenDialogEdit(true); } }
                            >
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
          </TableContainer>

          <TablePagination
            component='div'
            count={ countFiltered }
            page={ pagination.page }
            onChangePage={ (e, p) => {
              pagination.setPage(p);
            } }
            rowsPerPage={ pagination.limit }
            onChangeRowsPerPage={
              (e) => {
                const newLimit = parseInt(e.target.value, 10);
                pagination.setLimit(newLimit);
                pagination.setPage(0);
              }
            }
            rowsPerPageOptions={ [ 5, 10, 25 ] }
          />
        </Paper>
        <Dialog
          open={ openDialogEdit }
          onClose={ () => { setSelected({}); setOpenDialogEdit(false); } }
          classes={ { paper: classes.dialogPaperEdit } }
        >
          <DialogTitle>
            Edit
          </DialogTitle>
          <DialogContent className={ classes.dialogContent }>
            <Typography>
              <DialogContentText>
                <ManagersEditCorporate
                  selected={ selected }
                  setOpenDialogEdit={ setOpenDialogEdit }
                  refetch={ refetch }
                />
              </DialogContentText>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              className={ classes.button }
              onClick={ () => {
                setSelected({});
                setOpenDialogEdit(false);
              } }
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

      </Grid>
    </Grid>
  );
}

export default ManagerCorporationTable;
